module.exports = __webpack_public_path__ + "static/media/marigiti.c0116878.jpg";